export default {
  getFilas: state => state.filas,
  getFila: state => state.fila,
  getFilaUse: state => state.filaUse,
  getAudios: state => state.audios,
  getMusicasEmEspera: state => state.musicasEmEspera,
}
